import type { NewShowCaseList, ShowCaseList } from '@/app/types';
import { CommunityEnum } from '@/app/types';

/**
 * 根据类型获取对应的数据结构
 * @param item NewShowCaseList[number] | ShowCaseList[number]
 * @returns
 */
export const getCurrentItem = (item: NewShowCaseList[number] | ShowCaseList[number]) => {
  if (isShowCaseType(item)) {
    return item;
  }
  switch (item?.type) {
    case 'short_film':
      return item.short_film;
    case 'tutorial':
      return item.tutorial;
    case 'image_asset':
      return item.image_asset;
    case 'mini_video':
      return item.mini_video;
    default:
      return item.media_asset;
  }
};

/**
 * 判断属于哪种社区类型（视频灵感、短片、教程、图片灵感、小视频）
 * @param item NewShowCaseList[number] | ShowCaseList[number]
 * @returns
 */
export const getItemType = (item?: NewShowCaseList[number] | ShowCaseList[number]) => {
  switch (item?.type) {
    case 'short_film':
      return CommunityEnum.ShortFilm;
    case 'tutorial':
      return CommunityEnum.Tutorial;
    case 'reference2image':
    case 'text2image':
      return CommunityEnum.ImageAsset;
    case 'auto2video':
    case 'remix2video':
    case 'video_remix':
      return CommunityEnum.MiniVideo;
    default:
      return CommunityEnum.MediaAsset;
  }
};

/**
 * 判断是否是展示案例
 * @param item NewShowCaseList[number] | ShowCaseList[number]
 * @returns
 */
export function isShowCaseType(item: NewShowCaseList[number] | ShowCaseList[number]): item is ShowCaseList[number] {
  return !!(item as ShowCaseList[number]).id;
}
